var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"bubble-wrapper"},[_c('div',{ref:"bubble",staticClass:"bubble"},[_c('img',{staticClass:"bubble-image",attrs:{"src":require("../assets/nba.png")}})]),(_vm.text)?_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),_c('div',{ref:"bubblePulse",staticClass:"bubble-pulse"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }